import React from 'react';
import { TipBoxProps } from '@/components/tip-box/types';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import Icon from '@/components/icon/Icon';

export const TipBox: React.FC<TipBoxProps> = ({ title, description }) => {
  return (
    <div className="tip-box-element w-full">
      <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
        <div className="col-start-1 col-end-13 flex flex-col gap-6 lg:col-start-3 lg:col-end-11 xl:col-start-4 xl:col-end-10">
          <div className="flex flex-col gap-4 rounded-lg bg-brand-600 p-4">
            <div className="flex flex-row items-start gap-2 text-white">
              <Icon name="lightbulb" />
              <h4 className="text-2xl font-medium">{title}</h4>
            </div>
            {description && (
              <div className="tip-box-content">
                <SerializeDescription description={description} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
